import React from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ResourceListSource} from '../../../settings/helpers/resourceTableHooks';
import {BaseFilterDropdownProps} from './common/types';
import {
  ResourceMultiselectFilterDropdownBaseProps,
  useResourceMultiSelectFilterDropdownHelpers,
} from './resourceMultiSelectFilterDropdown';
import {FilterQueryDropdown} from './sourceFilter/filterQueryDropdown';

/*
 * Props.
 */

interface ResourceMultiselectFilterQueryDropdownBaseProps<T>
  extends Omit<ResourceMultiselectFilterDropdownBaseProps<T>, 'dropdownSource'> {
  searchQuery: string;
  onSearchQuery: HandlerOf<string>;
  dropdownSource: ResourceListSource<T>;
}

interface ResourceMultiselectFilterQueryDropdownProps<T>
  extends ResourceMultiselectFilterQueryDropdownBaseProps<T>,
    BaseFilterDropdownProps {}

/*
 * Component.
 */

export const ResourceMultiSelectFilterQueryDropdown = <T,>(
  props: ResourceMultiselectFilterQueryDropdownProps<T>,
) => {
  const {
    dropdownTitle,
    dropdownSource,
    computeFilterGenerator,
    selectedItemIds: previousSelectedItemIds,
    onSetItems,
    onClearAll,
    clearBehavior,
    searchQuery,
    onSearchQuery,
    applyButtonLabel,
    ...popoverTransferProps
  } = props;

  const {clearNewSelection, filterResourceWithHandler, showClearButton, isApplyDisabled, onClear, setItems} =
    useResourceMultiSelectFilterDropdownHelpers({
      computeFilterGenerator,
      onSetItems,
      previousSelectedItemIds,
      searchQuery,
      clearBehavior,
    });

  return (
    <FilterQueryDropdown
      {...popoverTransferProps}
      title={dropdownTitle}
      source={dropdownSource}
      filterResourceOf={filterResourceWithHandler}
      onClear={onClear}
      showClearButton={showClearButton}
      searchProps={{searchQuery, setSearchQuery: onSearchQuery}}
      onRequestClose={() => {
        if (popoverTransferProps.onRequestClose) {
          popoverTransferProps.onRequestClose();
        }
        clearNewSelection();
      }}
      footerHandlers={{
        onApplyClicked: setItems,
        onCancelClicked: clearNewSelection,
        applyButtonLabel,
        isApplyDisabled,
      }}
    />
  );
};
